import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CommonsConfiguration } from 'src/app/configuration/commons/commons-configuration';
import { AuthConfiguration } from 'src/app/configuration/auth/auth-configuration';
import { SecuredConfiguration } from 'src/app/configuration/secured/secured-configuration';
import { Observable } from 'rxjs';
import { YamlMenuHomePage } from '../../model/yaml-menu-home-page';
import { DizionarioView } from '../../model/dizionario-view';
import { ListaCompetenzeView } from '../../model/lista-competenze-view';
import { RicercaCompetenzeView } from '../../model/ricerca-competenze-view';
import { RicercaArchivioProposteView } from '../../model/ricerca-archivio-proposte-view';
import { ListaArchivioProfiliView } from '../../model/lista-archivio-profili-view';
import { RicercaArchivioCompetenzeView } from '../../model/ricerca-archivio-competenze-view';
import { ListaArchivioCompetenzeView } from '../../model/lista-archivio-competenze-view';
import { RicercaAssembleaView } from '../../model/ricerca-assemblea-view';
import { ListaAssembleeView } from '../../model/lista-assemblee-view';
import { CompetenzaView } from '../../model/competenza-view';
import { ListaConoscenzeView } from '../../model/lista-conoscenze-view';
import { AssembleaView } from 'src/app/model/assemblea-view';
import { InvioView } from 'src/app/model/invio-view';
import { ProfiloView } from 'src/app/model/profilo-view';
import { LongView } from 'src/app/model/long-view';

@Injectable({
  providedIn: 'root'
})
export class HttpService {
  headers = new HttpHeaders({
    'Content-Type': 'application/json',
  })
  constructor(public http: HttpClient) { }


  // menù della pagina Welcome
  getMenuHomePage(): Observable<YamlMenuHomePage[]> {
    return this.http.get<YamlMenuHomePage[]>(CommonsConfiguration.getMenuHomePage, { headers: this.headers });
  }

  // setta il ruolo utente
  setRuoloAttivo(id: any): Observable<any[]> {
    return this.http.get<any[]>(AuthConfiguration.setRuoloAttivo + id, { headers: this.headers });
  }


  // INVIO AI TECNICI
  sendProfilo(id: any): Observable<InvioView[]> {
    return this.http.get<InvioView[]>(SecuredConfiguration.sendProfilo + id, { headers: this.headers });
  }


  sendCompetenza(id: any): Observable<InvioView[]> {
    return this.http.get<InvioView[]>(SecuredConfiguration.sendCompetenza + id, { headers: this.headers });
  }



  // VALORIZZAZIONE SELECT SEARCHBOX
  // recupera l'elenco aree per la ricerca profilo
  getTAreaProfiloAttivo(): Observable<DizionarioView[]> {
    return this.http.get<DizionarioView[]>(SecuredConfiguration.getTAreaProfiloAttivo, { headers: this.headers });
  }

  getTAreaProfilo(): Observable<DizionarioView[]> {
    return this.http.get<DizionarioView[]>(CommonsConfiguration.getTAreaProfilo, { headers: this.headers });
  }

  getTipologiaCompetenza(): Observable<DizionarioView[]> {
    return this.http.get<DizionarioView[]>(CommonsConfiguration.getTipologiaCompetenza, { headers: this.headers });
  }

  getTipologiaCategoriaBase():  Observable<any>{
    return this.http.get<any>(CommonsConfiguration.getSottoCategoriaCompetenzaDiBase, {headers : this.headers});
  }

  getStatoPropostaPerElenco(): Observable<DizionarioView[]> {
    return this.http.get<DizionarioView[]>(SecuredConfiguration.getStatoPropostaPerElenco, { headers: this.headers });
  }

  getStatiCompetenzaPerFunzioneElenco(): Observable<DizionarioView[]> {
    return this.http.get<DizionarioView[]>(SecuredConfiguration.getStatiCompetenzaPerFunzioneElenco, { headers: this.headers });
  }

  getStatoPropostaPerArchivio(): Observable<DizionarioView[]> {
    return this.http.get<DizionarioView[]>(SecuredConfiguration.getStatoPropostaPerArchivio, { headers: this.headers });
  }

  getStatoCompetenzaPerArchivio(): Observable<DizionarioView[]> {
    return this.http.get<DizionarioView[]>(SecuredConfiguration.getStatoCompetenzaPerArchivio, { headers: this.headers });
  }

  // FINE VALORIZZAZIONE SELECT SEARCHBOX



  // ricerca profili
  ricercaProfili(data: any, page: number, pageSize: number): Observable<any[]> {
    return this.http.post<any[]>(SecuredConfiguration.ricercaProfili + page + '/' + pageSize, data, { headers: this.headers });
  }

  // ricerca profili regione
  ricercaProfiliRegione(data: any, page: number, pageSize: number): Observable<any[]> {
    return this.http.post<any[]>(SecuredConfiguration.ricercaProfiliRegione + page + '/' + pageSize, data, { headers: this.headers });
  }


  // ricerca competenze
  ricercaCompetenze(data: RicercaCompetenzeView, page: number, pageSize: number): Observable<ListaCompetenzeView[]> {
    return this.http.post<ListaCompetenzeView[]>(SecuredConfiguration.ricercaCompetenze + page + '/' + pageSize, data, { headers: this.headers });
  }

  ricercaCompetenzeHP(data: any, page: number, pageSize: number): Observable<ListaCompetenzeView[]> {
    return this.http.post<ListaCompetenzeView[]>(SecuredConfiguration.ricercaCompetenzeHP + page + '/' + pageSize, data, { headers: this.headers });
  }

  ricercaProfiliProfessionali(data: any, page: number, pageSize: number): Observable<ListaCompetenzeView[]> {
    return this.http.post<ListaCompetenzeView[]>(SecuredConfiguration.ricercaProfiliProfessionali + page + '/' + pageSize, data, { headers: this.headers });
  }

  // ricerca competenze regione
  ricercaCompetenzeRegione(data: RicercaCompetenzeView, page: number, pageSize: number): Observable<ListaCompetenzeView[]> {
    return this.http.post<ListaCompetenzeView[]>(SecuredConfiguration.ricercaCompetenzeRegione + page + '/' + pageSize, data, { headers: this.headers });
  }

  // ricerca archivio proposte
  ricercaArchivioProposte(data: RicercaArchivioProposteView, page: number, pageSize: number): Observable<ListaArchivioProfiliView[]> {
    return this.http.post<ListaArchivioProfiliView[]>(SecuredConfiguration.ricercaArchivioProposte + page + '/' + pageSize, data, { headers: this.headers });
  }

  // ricerca archivio competenze
  ricercaArchivioCompetenze(data: RicercaArchivioCompetenzeView, page: number, pageSize: number): Observable<ListaArchivioCompetenzeView[]> {
    return this.http.post<ListaArchivioCompetenzeView[]>(SecuredConfiguration.ricercaArchivioCompetenze + page + '/' + pageSize, data, { headers: this.headers });
  }

  // ricerca assemblea
  ricercaAssemblea(data: RicercaAssembleaView, page: number, pageSize: number): Observable<ListaAssembleeView[]> {


    return this.http.post<ListaAssembleeView[]>(SecuredConfiguration.ricercaAssemblea + page + '/' + pageSize, data, { headers: this.headers });
  }

  // ricerca assemblea
  ricercaCodiceProfilo(codiceProfilo: number, idProposta: number): Observable<ListaAssembleeView[]> {
    return this.http.get<any>(SecuredConfiguration.ricercaCodiceProfilo + codiceProfilo + '/' + idProposta, { headers: this.headers });
  }

  archiviaProfiloEProposta(data : any, idProposta : number): Observable<DizionarioView> {
    return this.http.post<DizionarioView>(SecuredConfiguration.archiviaProfiloEProposta + "/" + idProposta, data, { headers: this.headers });
  }


  // ricerca utenti
  ricercaUtenti(data: any, page: number, pageSize: number): Observable<any[]> {
    return this.http.post<any[]>(SecuredConfiguration.ricercaUtenti + page + '/' + pageSize, data, { headers: this.headers });
  }


  // ricerca operatori
  ricercaOperatori(data: any, page: number, pageSize: number): Observable<any[]> {
    return this.http.post<any[]>(SecuredConfiguration.ricercaOperatori + page + '/' + pageSize, data, { headers: this.headers });
  }


  // SEZIONE DETTAGLI
  // dettaglio profilo
  getProfilo(id: any): Observable<any[]> {
    return this.http.get<any[]>(SecuredConfiguration.getProfilo + id, { headers: this.headers });
  }

  // dettaglio profilo
  getProfiloDettaglio(id: any): Observable<any[]> {
    return this.http.get<any[]>(SecuredConfiguration.getProfiloDettaglio + id, { headers: this.headers });
  }

  validaProfilo(data:any): Observable<any[]> {
    return this.http.post<any[]>(SecuredConfiguration.validaProfilo, data, { headers: this.headers });
  }

  rifiutaProfilo(data:any): Observable<any[]> {
    return this.http.post<any[]>(SecuredConfiguration.rifiutaProfilo, data, { headers: this.headers });
  }

  eliminaProfilo(id: any): Observable<any[]> {
    return this.http.get<any[]>(SecuredConfiguration.eliminaProfiloProfessionale+id, { headers: this.headers });
  }

  eliminaCompetenza(id: any): Observable<any[]> {
    return this.http.get<any[]>(SecuredConfiguration.eliminaCompetenza+id, { headers: this.headers });
  }

  salvaModificaProfilo(data:any): Observable<any[]> {
    return this.http.post<any[]>(SecuredConfiguration.saveModificaProfilo, data, { headers: this.headers });
  }

  // dettaglio competenza
  getCompetenza(id: any): Observable<any[]> {
    return this.http.get<any[]>(SecuredConfiguration.getCompetenza + id, { headers: this.headers });
  }


  saveProfilo(data: any): Observable<any[]> {
    return this.http.post<any[]>(SecuredConfiguration.saveProfilo, data, { headers: this.headers });
  }

  saveCompetenza(data: any): Observable<any[]> {
    return this.http.post<any[]>(SecuredConfiguration.saveCompetenza, data, { headers: this.headers });
  }

  // ASSOCIAZIONE CLASSIFICAZIONI
  getTipoProcessi(id: any): Observable<DizionarioView[]> {
    return this.http.get<DizionarioView[]>(SecuredConfiguration.getTipoProcessi + id, { headers: this.headers });
  }

  getTipoSequenze(id: any, processoId: any): Observable<DizionarioView[]> {
    return this.http.get<DizionarioView[]>(SecuredConfiguration.getTipoSequenze + id + "/" + processoId, { headers: this.headers });
  }

  getTipoSottoarea(id: any): Observable<DizionarioView[]> {
    return this.http.get<DizionarioView[]>(SecuredConfiguration.getTipoSottoarea + id, { headers: this.headers });
  }

  // ASSOCIAZIONE COMPETENZE
  getCompetenzeByIdProposta(id: any): Observable<CompetenzaView[]> {
    return this.http.get<CompetenzaView[]>(SecuredConfiguration.getCompetenzeByIdProposta + id, { headers: this.headers });
  }

  getRicercaCompetenzeDaAssociare(data: any, page: number, pageSize: number): Observable<ListaCompetenzeView[]> {
    return this.http.post<ListaCompetenzeView[]>(SecuredConfiguration.getRicercaCompetenzeDaAssociare + page + '/' + pageSize, data, { headers: this.headers });
  }

  getRicercaCompetenzeValidateDaAssociare(data: any, page: number, pageSize: number): Observable<ListaCompetenzeView[]> {
    return this.http.post<ListaCompetenzeView[]>(SecuredConfiguration.getRicercaCompetenzeValidateDaAssociare + page + '/' + pageSize, data, { headers: this.headers });
  }

  getCompetenzaDettaglio(id: any): Observable<CompetenzaView[]> {
    return this.http.get<CompetenzaView[]>(SecuredConfiguration.getCompetenzaDettaglio + id, { headers: this.headers });
  }

  modificaCompetenza(id: any): Observable<CompetenzaView[]> {
    return this.http.get<CompetenzaView[]>(SecuredConfiguration.getCompetenzaDettaglio + id, { headers: this.headers });
  }

  associaCompetenze(data: any, id: any): Observable<any[]> {
    return this.http.post<any[]>(SecuredConfiguration.associaCompetenze + id, data, { headers: this.headers });
  }

  validaCompetenza(data:any): Observable<any[]> {
    return this.http.post<any[]>(SecuredConfiguration.validaCompetenza, data, { headers: this.headers });
  }

  rifiutaCompetenza(data:any): Observable<any[]> {
    return this.http.post<any[]>(SecuredConfiguration.rifiutaCompetenza, data, { headers: this.headers });
  }

  salvaCompetenza(data:any): Observable<any[]> {
    return this.http.post<any[]>(SecuredConfiguration.salvaCompetenza, data, { headers: this.headers });
  }

  salvaModificaCompetenza(data:any): Observable<any[]> {
    return this.http.post<any[]>(SecuredConfiguration.salvaModificaCompetenza, data, { headers: this.headers });
  }

  reportPropostaCompetenzaPdf(id: any) {
    window.open(SecuredConfiguration.reportPropostaCompetenzaPdf + id, "_blank");
  }

  reportPropostaCompetenzaPdfHP(id: any) {
    window.open("https://qrsp.servizirl.it/qrsp/commons/commons/reportPropostaCompetenzaPdf/" + id, "_blank");
  }

  reportPropostaCompetenzaXls(id: any) {
    window.open(SecuredConfiguration.reportPropostaCompetenzaXls + id, "_blank");
  }

  // ASSOCIAZIONE CONOSCENZE
  getAssociazioniConoscenze(id: number, descrizione : string|null, page : number, size: number): Observable<DizionarioView[]> {
    return this.http.get<any>(`${SecuredConfiguration.getAssociazioniConoscenze}/${id}/${descrizione}/${page}/${size}`, { headers: this.headers });
  }

  getConoscenzeByCompetenza(id: any): Observable<DizionarioView[]> {
    return this.http.get<DizionarioView[]>(SecuredConfiguration.getConoscenzeByCompetenza + id, { headers: this.headers });
  }

  ricercaConoscenze(data: any, page: number, pageSize: number): Observable<ListaConoscenzeView[]> {
    return this.http.post<ListaConoscenzeView[]>(SecuredConfiguration.ricercaConoscenze + page + '/' + pageSize, data, { headers: this.headers });
  }


  associaConoscenza(data: any, id: any): Observable<any[]> {
    return this.http.post<any[]>(SecuredConfiguration.associaConoscenza + id, data, { headers: this.headers });
  }

  // CREAZIONE CONOSCENZE

  saveConoscenza(data: any): Observable<any[]> {
    return this.http.post<any[]>(SecuredConfiguration.saveConoscenza, data, { headers: this.headers });
  }

  // ASSOCIAZIONE ABILITA
  getAbilitaByCompetenza(id: any): Observable<DizionarioView[]> {
    return this.http.get<DizionarioView[]>(SecuredConfiguration.getAbilitaByCompetenza + id, { headers: this.headers });
  }

  ricercaAbilita(data: any, page: number, pageSize: number): Observable<any[]> {
    return this.http.post<any[]>(SecuredConfiguration.ricercaAbilita + page + '/' + pageSize, data, { headers: this.headers });
  }


  associaAbilita(data: any, id: any): Observable<any[]> {
    return this.http.post<any[]>(SecuredConfiguration.associaAbilita + id, data, { headers: this.headers });
  }

  reportProfiloProfessionalePdf(id: any) {
    window.open(SecuredConfiguration.reportProfiloProfessionalePdf + id, "_blank");
  }

  reportProfiloProfessionalePdfHP(id: any) {
    window.open("https://qrsp.servizirl.it/qrsp/commons/commons/reportProfiloProfessionalePdf/" + id, "_blank");
  }

   // CREAZIONE ABILITA

   saveAbilita(data: any): Observable<any[]> {
    return this.http.post<any[]>(SecuredConfiguration.saveAbilita, data, { headers: this.headers });
  }

  // reportProfiloProfessionalePdfHP(id: any) {
  //   return this.http.get<any>(SecuredConfiguration.reportProfiloProfessionalePdfHP + id, { headers: this.headers });

  // }

  reportProfiloProfessionaleXls(id: any) {
    window.open(SecuredConfiguration.reportProfiloProfessionaleXls + id, "_blank");
  }


  // ASSEMBLEA

  getAssemblea(id:any): Observable<AssembleaView[]> {
    return this.http.get<AssembleaView[]>(SecuredConfiguration.getAssemblea + id, { headers: this.headers });
  }

  salvaAssemblea(data: any): Observable<any[]> {
    return this.http.post<any[]>(SecuredConfiguration.salvaAssemblea, data, { headers: this.headers });
  }

  getProfiliAssegnati(id:any): Observable<ProfiloView[]> {
    return this.http.get<ProfiloView[]>(SecuredConfiguration.getProfiliAssegnati + id, { headers: this.headers });
  }

  getCompetenzeAssegnateAssemblea(id:any): Observable<CompetenzaView[]> {
    return this.http.get<CompetenzaView[]>(SecuredConfiguration.getCompetenzeAssegnateAssemblea + id, { headers: this.headers });
  }

  chiudiAssemblea(data: any): Observable<any[]> {
    return this.http.post<any[]>(SecuredConfiguration.chiudiAssemblea, data, { headers: this.headers });
  }

  confermaAssemblea(data: any): Observable<any[]> {
    return this.http.post<any[]>(SecuredConfiguration.confermaAssemblea, data, { headers: this.headers });
  }


  cancellaAssemblea(id:any): Observable<any[]> {
    return this.http.get<any[]>(SecuredConfiguration.cancellaAssemblea + id, { headers: this.headers });
  }

  ricercaCompetenzeValidate(data: any, page: number, pageSize: number): Observable<any[]> {
    return this.http.post<any[]>(SecuredConfiguration.ricercaCompetenzeValidate + page + '/' + pageSize, data, { headers: this.headers });
  }

  ricercaProfiliValidati(data: any, page: number, pageSize: number): Observable<any[]> {
    return this.http.post<any[]>(SecuredConfiguration.ricercaProfiliValidati + page + '/' + pageSize, data, { headers: this.headers });
  }

  associaCompetenzeAssemblea(data: any, id: any): Observable<any[]> {
    return this.http.post<any[]>(SecuredConfiguration.associaCompetenzeAssemblea + id, data, { headers: this.headers });
  }

  associaProfiliAssemblea(data: any, id: any): Observable<any[]> {
    return this.http.post<any[]>(SecuredConfiguration.associaProfiliAssemblea + id, data, { headers: this.headers });
  }

  precaricaCodiceProfilo(id:any) : Observable<any[]> {
    return this.http.get<any[]>(SecuredConfiguration.precaricaCodiceProfilo + id, { headers: this.headers });
  }

  assegnaCodiceProfilo(data: any): Observable<any[]> {
    return this.http.post<any[]>(SecuredConfiguration.assegnaCodiceProfilo, data, { headers: this.headers });
  }

  salvaAssembleaDecreto(data: any): Observable<any[]> {
    return this.http.post<any[]>(SecuredConfiguration.salvaAssembleaDecreto, data, { headers: this.headers });
  }

  // UTENZE
  caricaUtente(cf:any): Observable<any[]> {
    return this.http.get<any[]>(SecuredConfiguration.caricaUtente + cf, { headers: this.headers });
  }

  caricaRuoliUtenti(): Observable<any[]> {
    return this.http.get<any[]>(SecuredConfiguration.caricaRuoliUtenti, { headers: this.headers });
  }

  getOperatoreByRuolo(id:any): Observable<any[]> {
    return this.http.get<any[]>(SecuredConfiguration.getOperatoreByRuolo + id, { headers: this.headers });
  }

  salvaUtenza(data: any): Observable<any[]> {
    return this.http.post<any[]>(SecuredConfiguration.salvaUtenza, data, { headers: this.headers });
  }

  disableUtente(id:any): Observable<any[]> {
    return this.http.get<any[]>(SecuredConfiguration.disableUtente + id, { headers: this.headers });
  }

  abilitaUtente(id:any): Observable<any[]> {
    return this.http.get<any[]>(SecuredConfiguration.abilitaUtente + id, { headers: this.headers });
  }



  // OPERATORI

  getComuni(id:any): Observable<DizionarioView[]> {
    return this.http.get<DizionarioView[]>(SecuredConfiguration.getComuni + id, { headers: this.headers });
  }

  getProvince(): Observable<DizionarioView[]> {
    return this.http.get<DizionarioView[]>(SecuredConfiguration.getProvince, { headers: this.headers });
  }

  caricaOperatore(id:any): Observable<any> {
    return this.http.get<any>(SecuredConfiguration.caricaOperatore + id + '/true', { headers: this.headers });
  }

  etlSedi(): Observable<any> {
    return this.http.get<any>(SecuredConfiguration.etlSedi, { headers: this.headers });
  }

  etlOperatori(): Observable<any> {
    return this.http.get<any>(SecuredConfiguration.etlOperatori, { headers: this.headers });
  }

  saveSede(operatoreId : number, data: any): Observable<any[]> {
    return this.http.post<any>(`${SecuredConfiguration.saveSede}/${operatoreId}`, data, { headers: this.headers });
  }

  saveOperatore(data: any): Observable<any[]> {
    return this.http.post<any[]>(SecuredConfiguration.saveOperatore, data, { headers: this.headers });
  }

  abilitaOperatore(id:any): Observable<any> {
    return this.http.get<any>(SecuredConfiguration.abilitaOperatore + id, { headers: this.headers });
  }

  disabilitaOperatore(id:any): Observable<any> {
    return this.http.get<any>(SecuredConfiguration.disabilitaOperatore + id, { headers: this.headers });
  }

  uploadDocumentoDecreto(file:any): Observable<LongView[]> {
    let formData: FormData = new FormData();
    formData.append("file", file);
    return this.http.post<LongView[]>(SecuredConfiguration.uploadFile + '?fileName=' + file.name + '&tipoArea=0', formData);
  }

  // DUPLICAZIONE PROFILO
  duplicaProfilo(id:any): Observable<any> {
    return this.http.get<any>(SecuredConfiguration.duplicaProfilo + id, { headers: this.headers });
  }

  saveDuplicaProfilo(data: any, id: any): Observable<any[]> {
    return this.http.post<any[]>(SecuredConfiguration.saveDuplicaProfilo + id, data, { headers: this.headers });
  }


  // ARCHIVIAZIONE
  archiviaCompetenza(data: any): Observable<any[]> {
    return this.http.post<any[]>(SecuredConfiguration.archiviaCompetenza, data, { headers: this.headers });
  }

  archiviaProposta(data: any): Observable<any[]> {
    return this.http.post<any[]>(SecuredConfiguration.archiviaProposta, data, { headers: this.headers });
  }

  // ASSISTENZA
  assistenza(data: FormData): Observable<any[]> {
    return this.http.post<any[]>(CommonsConfiguration.inviaEmailAssistenza, data);
  }

  // getLogout(): Observable<any> {
  //   return this.http.get<any>(CommonsConfiguration.getLogout, { headers: this.headers });
  // }

  // CARICA DECRETI
  getTipoAreaCaricamento(): Observable<any> {
    return this.http.get<any>(SecuredConfiguration.getTipoAreaCaricamento , { headers: this.headers });
  }

  getTipologieAllegato(): Observable<any> {
    return this.http.get<any>(SecuredConfiguration.getTipologieAllegato , { headers: this.headers });
  }

  downloadAllegato(idTAllegato: number): Observable<Blob> {
    return this.http.get(`${SecuredConfiguration.downloadAllegato}/${idTAllegato}`, {
      responseType: 'blob'
    });
  }

  getDocumenti(id:any, page: number, pageSize: number): Observable<any> {
    return this.http.get<any>(SecuredConfiguration.getDocumenti + id + '/'+ page + '/' + pageSize, { headers: this.headers });
  }

  getDocumento(id:any, idTipoArea: number): Observable<any> {
    return this.http.get<any>(SecuredConfiguration.getDocumento + idTipoArea + '/' + id, { headers: this.headers });
  }

  salvaAreaCaricamento(data: any): Observable<any[]> {
    return this.http.post<any[]>(SecuredConfiguration.salvaAreaCaricamento, data, { headers: this.headers });
  }

  eliminaDocumento(id: any): Observable<any[]> {
    return this.http.get<any[]>(SecuredConfiguration.eliminaDocumento+id, { headers: this.headers });
  }

  uploadDocumento(file:any,idTipoArea:any): Observable<LongView[]> {
    let formData: FormData = new FormData();
    formData.append("file", file);

    return this.http.post<LongView[]>(SecuredConfiguration.uploadFile + '?fileName=' + file.name + '&tipoArea=' + idTipoArea, formData);
  }

  // ARCHIVIO ABILITA E CONOSCENZE

  getTipologie(): Observable<any> {
    return this.http.get<any>(SecuredConfiguration.getTipologie , { headers: this.headers });
  }

  getTipoStati(): Observable<any> {
    return this.http.get<any>(SecuredConfiguration.getTipoStati , { headers: this.headers });
  }

  ricercaAbilitaConoscenze(data: any): Observable<any[]> {
    return this.http.post<any[]>(SecuredConfiguration.ricercaAbilitaConoscenze, data, { headers: this.headers });
  }

  ricercaCompetenzeArchivio(tipoRicerca: any, id:any): Observable<any> {
    return this.http.get<any>(SecuredConfiguration.ricercaCompetenzeArchivio + '/' + tipoRicerca + '/' + id, { headers: this.headers });
  }

  getStatiAssemblea(): Observable<DizionarioView[]> {
    return this.http.get<DizionarioView[]>(SecuredConfiguration.getStatiAssemblea, { headers: this.headers });
  }

  downloadDocumento(data:any)  {
    return this.http.post(SecuredConfiguration.downloadDocumentoPdf, data, { responseType: 'blob' });
  }

  downloadService(data: any, fileName: string) {
    const blob = new Blob([data], {type: 'application/octet-stream'});
    let element = document.createElement('a');
    element.href = window.URL.createObjectURL(blob);
    element.download = fileName;
    element.click();
  }

  ricercaListaTipoOperatori(): Observable<any[]> {
    return this.http.get<any[]>(SecuredConfiguration.ricercaListaTipoOperatori);
  }

  logout(url: string) {
		return this.http.post(SecuredConfiguration.logout + '?destination=' + url, { headers: this.headers });
	}

  getUrlRedirect():Observable<DizionarioView> {
    return this.http.get<DizionarioView>(SecuredConfiguration.getUrlRedirect);
  }

}
